import businessTitle from './businessTitle'
export default {
  computed: {
    chatDrawer: {
      get () {
        return this.$store.state.chatDrawer
      },
      set (v) {
        this.$store.commit('setChatDrawer', v)
      }
    },
    fakerHeaders () {
      let arr = []
      for (let i = 0; i < 32; i++) {
        arr.push({})
      }
      return arr
    },
    isAdmin () {
      return this.$store.getters.isAdmin
    },
    isMaster () {
      return this.$store.getters.isMaster
    },
    isFounder () {
      return this.$store.getters.isMaster && this.$store.state.user.id === 1
    },
    isOwner () {
      if (this.isAdmin) return true
      if (!this.$store.state.project) return false
      return this.$store.state.project.owner === this.$store.state.user.id
    }
  },
  methods: {
    getUsername (user) {
      if (!this.isAdmin && user.business_title) {
        return this.getBusinessTitle(user.business_title)
      }
      if (this.isAdmin && !this.$store.state.devMode && user.business_title) {
        return this.getBusinessTitle(user.business_title)
      }
      return user.username
    },
    isCurrentUser (id) {
      return this.$store.state.user.id === id
    },
    viewImage (url) {
      this.$tkGlobal.viewImage.show(url)
    },
    copyString (str, container) {
      if (!container) container = document.body
      let el = document.createElement('textarea')
      el.value = str
      el.setAttribute('readonly', '')
      el.style = { position: 'absolute', left: '-9999px', zIndex: '9999' }
      container.appendChild(el)
      el.select()
      document.execCommand('copy')
      container.removeChild(el)
    },
    hasModule (name) {
      if (!this.$store.state.project) return false
      return this.$store.state.project.module.includes(name)
    },
    getBusinessTitle (name) {
      return businessTitle[name] || '工程师'
    },
    getFields (name, type) {
      if (!this.$store.state.project) return
      let fields = []
      let manager = this.$store.getters.model.find(item => {
        return item.className === name
      })
      manager = JSON.parse(JSON.stringify(manager))
      let classes = this.$store.state.project.schema.find(
        item => item.className === name
      )
      manager.fields.forEach(field => {
        if (field.name === 'createdAt' || field.name === 'updatedAt') return
        if (type === 'list' && field.hideOnList) return
        if (
          classes.fields[field.name] &&
          (classes.fields[field.name].type === 'Pointer' ||
            (classes.fields[field.name].type === 'Array' &&
              classes.fields[field.name].items.type === 'Pointer'))
        ) {
          let targetClass =
            classes.fields[field.name].targetClass ||
            classes.fields[field.name].items.targetClass
          let cls = this.project.schema.find(i => {
            return i.className === targetClass
          })
          if (!cls) {
            console.log(targetClass)
          }
          if (!field.note) field.note = cls.classNote || field.name
          field.cls = JSON.parse(JSON.stringify(cls))
        }
        if (!field.note) field.note = field.name
        fields.push(Object.assign({}, field, classes.fields[field.name]))
      })
      if (type === 'list') {
        fields.push({
          name: 'createdAt',
          type: 'Date',
          note: '创建时间'
        })
        fields.push({
          name: 'updatedAt',
          type: 'Date',
          note: '更新时间'
        })
      }
      return fields
    },
    logout () {
      this.$store.commit('logout')
      this.$router.push('/login')
    },
    hasPermission (permission) {
      if (!this.isAdmin) return false
      if (this.isMaster) return true
      return this.$store.state.user.permissions && this.$store.state.user.permissions.includes(permission)
    },
    can (action, type, cls) {
      if (this.isAdmin || this.isOwner) return true
      if (!this.$store.state.project) return false
      let role = this.$store.state.project.teamRole
      if (!role) return false
      if (!role[type]) return false
      if (cls) {
        return role[type][cls] && role[type][cls][action]
      } else {
        return role[type][action]
      }
    }
  }
}
